// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import Vue from 'vue'
import CreateAPI from 'vue-create-api'
import {
  Picker,
  TabPicker,
  Selector,
  Captcha,
  Dialog,
} from 'mand-mobile'
import MainLoading from '~/components/common/loading.vue'

Vue.use(CreateAPI)
Vue.createAPI(MainLoading, [], false)

Vue.createAPI(Picker, [], true)
Vue.createAPI(
  TabPicker,
  ['select', 'change', 'hide', 'show'],
  true
)
Vue.createAPI(
  Selector,
  ['confirm', 'choose', 'cancel', 'hide', 'show'],
  true
)
Vue.createAPI(
  Captcha,
  ['send', 'submit', 'hide', 'show'],
  true
)
Vue.createAPI(Dialog, ['close', 'show', 'hide'], true)

// 品牌加载动画
let loading = null
export const createMainLoading = () => {
  return {
    show: () => {
      if (!loading) {
        loading = MainLoading.$create()
      }
      loading.show()
    },
    remove: () => {
      loading && loading.remove()
    },
  }
}
